// Examination selectors for lightweight approach
export const selectCurrentExamination = (state) => state.examination.currentExamination;
export const selectExaminationData = (state) => state.examination.currentExamination; // Alias for compatibility
export const selectExaminationError = (state) => state.examination.error;
export const selectQuestionError = (state) => state.examination.questionError;

// Loading states
export const selectExaminationLoading = (state) => state.examination.isLoading;
export const selectExaminationCreating = (state) => state.examination.isCreating;
export const selectExaminationStarting = (state) => state.examination.isStarting;
export const selectExaminationCompleting = (state) => state.examination.isCompleting;
export const selectExaminationSubmitting = (state) => state.examination.isSubmitting;
export const selectIsLoadingQuestion = (state) => state.examination.isLoadingQuestion;

// Navigation selectors (lightweight approach)
export const selectCurrentSectionIndex = (state) => state.examination.currentSectionIndex;
export const selectCurrentQuestionIndexInSection = (state) => state.examination.currentQuestionIndexInSection;
export const selectCurrentQuestion = (state) => state.examination.currentQuestion;
export const selectQuestionCache = (state) => state.examination.questionCache;

// Answer and user progress selectors
export const selectUserAnswers = (state) => state.examination.userAnswers;
export const selectTimeStatus = (state) => state.examination.timeStatus;

// Get cached question by index
export const selectCachedQuestion = (state, questionIndex) => {
    return state.examination.questionCache[questionIndex];
};

// Get user answer for specific question
export const selectUserAnswer = (state, questionIndex) => {
    return state.examination.userAnswers[questionIndex];
};

// Computed selectors
export const selectExaminationStatus = (state) => {
    const examination = state.examination.currentExamination;
    return examination?.status || 'not-started';
};

export const selectIsExaminationActive = (state) => {
    const status = selectExaminationStatus(state);
    return status === 'in-progress';
};

export const selectIsExaminationCompleted = (state) => {
    const status = selectExaminationStatus(state);
    return status === 'completed';
};

export const selectExaminationTimeRemaining = (state) => {
    const timeStatus = state.examination.timeStatus;
    return timeStatus?.timeRemaining || 0;
};

export const selectExaminationProgress = (state) => {
    const currentIndex = state.examination.currentQuestionIndex;
    const examination = state.examination.currentExamination;
    const totalQuestions = examination?.totalQuestions || 0;

    if (totalQuestions === 0) return 0;
    return Math.round((currentIndex / totalQuestions) * 100);
};

// Section navigation helpers
export const selectCanNavigateNext = (state) => {
    const currentIndex = state.examination.currentQuestionIndex;
    const examination = state.examination.currentExamination;
    const totalQuestions = examination?.totalQuestions || 0;

    return currentIndex < totalQuestions - 1;
};

export const selectCanNavigatePrevious = (state) => {
    const currentIndex = state.examination.currentQuestionIndex;
    return currentIndex > 0;
};

// Error and loading state helpers
export const selectHasExaminationError = (state) => {
    return !!state.examination.error;
};

export const selectIsAnyExaminationLoading = (state) => {
    const exam = state.examination;
    return exam.isLoading || exam.isCreating || exam.isStarting ||
        exam.isCompleting || exam.isSubmitting;
};